import { Spinner } from "@heroui/react";
import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";

import useAuth from "../hooks/use-auth";

/**
 * For use with routes that need authentication.
 * @returns {React.ReactElement} The authenticating layout.
 */
export function AuthnLayout() {
  const authData = useAuth();
  const location = useLocation();

  if (authData.isLoading()) {
    return (
      <div className="mt-8 flex justify-center">
        <Spinner color="primary" />
      </div>
    );
  }

  if (!authData.isLoggedIn()) {
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnUrl=${returnUrl}`} replace />;
  }

  return <Outlet />;
}
